import { useQuery, useQueryClient, useMutation } from 'react-query';

import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import {
  getUsers,
  getUserById,
  addUser,
  editUser,
  editAdminProfile,
  deleteUser,
  resetPass,
  editStatus,
} from './actions';

export const useUsers = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-users', params],
    queryFn: getUsers,
    retry: false,
    keepPreviousData: false,
  });
  const data = raw?.data?.data || [];
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useUserById = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-user-by-id', params],
    queryFn: getUserById,
    retry: false,
    keepPreviousData: false,
  });
  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useAddUser = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(addUser, {
    onSuccess: (res) => {
      queryClient.invalidateQueries('get-users');
      queryClient.invalidateQueries('get-user-by-id');
      toastSuccess('Successfully added user!');
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export const useEditUser = (onSuccess) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(editUser, {
    onSuccess: (res) => {
      queryClient.invalidateQueries('get-users');
      queryClient.invalidateQueries('get-user-by-id');
      toastSuccess('Successfully updated user!');
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError: (err) => toastError(err?.response?.data?.message),
  });
  return [isLoading, mutate];
};

export const useEditAdminProfile = (onSuccess) => {
  const { mutate, isLoading } = useMutation(editAdminProfile, {
    onSuccess: (res) => {
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError: (err) => toastError(err?.response?.data?.message),
  });
  return [isLoading, mutate];
};

export const useDeleteUser = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(deleteUser, {
    onSuccess: (res) => {
      queryClient.invalidateQueries('get-users');
      toastSuccess('Successfully deleted user!');
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export const useEditStatus = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(editStatus, {
    onSuccess: (res) => {
      queryClient.invalidateQueries('get-users');
      queryClient.invalidateQueries('get-user-by-id');
      toastSuccess('Successfully change status!');
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export const useResetPass = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(resetPass, {
    onSuccess: (res) => {
      queryClient.invalidateQueries('get-users');
      queryClient.invalidateQueries('get-user-by-id');
      toastSuccess('Successfully reset password!');
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export default {};
